import type {
    ActionAPIAuthError,
    ActionAPIError,
    ActionNetworkError,
    ActionResetNetworkError
} from 'shared/store/actions'
import { fetchPageData } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'
import type { Dispatch } from 'redux'
import { closeWebsocket } from 'shared/store/websocket'
import type { KingdomDashboardData } from 'shared/types/api'
import { ws } from 'shared/store/ws'

export type ActionDashboardDataResponse = {
    type: 'PAGE_DATA_DASHBOARD_RESPONSE',
    data: KingdomDashboardData
}

export type ActionDashboardLogout = {
    type: 'LOGOUT'
}

type ActionDashboardSigninSend = {
    type: 'SIGNIN_SEND_FORM_SUCCESS'
}

type ActionDashboardSigninSocial = {
    type: 'SOCIAL_PENDING'
}

type ActionDashboardSignupSend = {
    type: 'SIGNUP_SEND_FORM_SUCCESS'
}

type ActionLogoutDone = {
    type: 'LOGOUT_DONE'
}

type ActionDashboardError = {
    type: 'DASHBOARD_ERROR',
    dashboardError: boolean
}

const fetchDashboardPageData = () =>
    fetchPageData(endpoints.kingdom.dashboard, 'PAGE_DATA_DASHBOARD_RESPONSE')

const actionError = (dashboardError: boolean): ActionDashboardError => ({
    type: 'DASHBOARD_ERROR',
    dashboardError
})

const logout = (): ActionDashboardLogout => ({
    type: 'LOGOUT'
})

const logoutDone = ({ isGlobal }: { isGlobal: boolean }) => {
    if (isGlobal) {
        ws.post(endpoints.kingdom.profile.logout)
    }
    return (dispatch: Dispatch<any>) => {
        dispatch({
            type: 'LOGOUT_DONE'
        })
        closeWebsocket()
    }
}

export { actionError, logout, logoutDone, fetchDashboardPageData }

export type Action =
    | ActionDashboardDataResponse
    | ActionDashboardLogout
    | ActionDashboardSigninSend
    | ActionDashboardSigninSocial
    | ActionDashboardSignupSend
    | ActionLogoutDone
    | ActionDashboardError
    | ActionAPIError
    | ActionNetworkError
    | ActionResetNetworkError
    | ActionAPIAuthError
